import { useSelector } from "react-redux";
import { getBrandedFareOffers } from "../../store/flightDetails/selectors.js";
import { getFareOffersWithDetails } from "../../store/brandedFareOffers/selectors.js";
import useGetUrlParams from "../../hooks/useGetUrlParams.js";
const useAvailableBrandedFares = () => {
    const { getUrlParam } = useGetUrlParams();
    const baseOfferToken = process.env.BUILD_TARGET === "client" && getUrlParam("baseOfferToken");
    const brandedFareOffers = useSelector(getBrandedFareOffers) || [];
    const fareOffersWithDetails = useSelector(getFareOffersWithDetails);
    if (!baseOfferToken) {
        return brandedFareOffers;
    }
    return fareOffersWithDetails[baseOfferToken]?.brandedFareOffers || brandedFareOffers;
};
export default useAvailableBrandedFares;
